import type { PanchayatDataMap } from "./panchayat.types"

const protectedAdminSet: Set<string> = new Set()

export function getProtectedAdminSet(): Set<string> {
  return protectedAdminSet
}

export function seedProtectedAdminFromMap(map: PanchayatDataMap): void {
  Object.keys(map).forEach((district) => {
    if (district) protectedAdminSet.add(district)
    const blocks = map[district] || {}
    Object.keys(blocks).forEach((block: string) => {
      if (block) protectedAdminSet.add(block)
      const gps: string[] = blocks[block] || []
      gps.forEach((gp: string) => {
        if (gp) protectedAdminSet.add(gp)
      })
    })
  })
}
